import { queryOptions } from '@tanstack/react-query';

import { dealsBoardApi } from './api-handlers';
import { dealsBoardQueryKeys } from './query-keys';

export const { getDealsBoard } = dealsBoardApi;

export const getDealsBoardQueryOptions = () =>
    queryOptions({
        queryKey: dealsBoardQueryKeys.board(),
        queryFn: getDealsBoard,
        staleTime: 30_000
    });
